/**
 * @generated SignedSource<<d1c6a4443f43df40c591dc18ccde2516>>
 * @relayHash 78ebc659afe74e8704b97755d1bacd04
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd6f9266e351d29276dd1ba5736d5409d2d292e05b942c4deb29e4403b093448

import type { ConcreteRequest } from 'relay-runtime';
export type LimitsBannerV2Query$variables = {
  cloudId: string;
  filterKeys: ReadonlyArray<string>;
};
export type LimitsBannerV2Query$data = {
  readonly jira: {
    readonly limitValues: ReadonlyArray<{
      readonly key: string | null;
      readonly limitValue: number | null;
    } | null> | null;
  } | null;
};
export type LimitsBannerV2Query = {
  response: LimitsBannerV2Query$data;
  variables: LimitsBannerV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterKeys"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "filterKeys",
            "variableName": "filterKeys"
          }
        ],
        "concreteType": "JiraResourceUsageMetricLimitValue",
        "kind": "LinkedField",
        "name": "limitValues",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "limitValue"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LimitsBannerV2Query",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LimitsBannerV2Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "bd6f9266e351d29276dd1ba5736d5409d2d292e05b942c4deb29e4403b093448",
    "metadata": {},
    "name": "LimitsBannerV2Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5bec1274dc0dc95fb44977d28f01301d";

export default node;
